import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function BillDetail() {
  const { user } = useUser()
  let view = contentLayout[modules.BillDetail]
  // We check for bill_detail permission or bill_list permission (as fallback/base)
  const hasPermission = user.permissions.views.join().includes("bill_detail") || user.permissions.views.join().includes(modules.BillList.toLowerCase())
  
  if (user.permissions.views.length && !hasPermission) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.BillDetail}></Index>
  )
}

export default BillDetail
